import { Container, ImageContainer, TextContainer, Image, TitleContainer, ActionContainer, CheckCircle } from './styled'
import { H4, H5 } from 'views/components/UI/Text'
import AddIcon from '@mui/icons-material/Add'
import CheckIcon from '@mui/icons-material/Check'

import noImg from 'assets/images/no-image.png'

interface IProps {
  image: string
  title: string
  subtitle?: string
  onClick: () => void
  checked: boolean
}

function Index(props: IProps) {
  const { image, title, subtitle, onClick, checked } = props

  return (
    <Container isChecked={checked} onClick={onClick}>
      <ImageContainer>{image ? <Image src={image} /> : <Image src={noImg} />}</ImageContainer>
      <TextContainer>
        <TitleContainer>
          <H4>{title || 'Inserte titulo'}</H4>
          <H5 style={{ fontWeight: 'normal' }}>{subtitle || 'Inserte sub título'}</H5>
        </TitleContainer>
        <ActionContainer>
          <CheckCircle checked={checked}>
            {checked ? <CheckIcon style={{ color: '#ffffff' }} /> : <AddIcon style={{ color: '#C6016B' }} />}
          </CheckCircle>
        </ActionContainer>
      </TextContainer>
    </Container>
  )
}

export default Index
